export function gifAnimation({ width, height, frames }) {
  const canvas = document.createElement('canvas'), patch = document.createElement('canvas'), backup = document.createElement('canvas');
  canvas.width = backup.width = width; canvas.height = backup.height = height;
  const ctx = canvas.getContext('2d'), patchCtx = patch.getContext('2d'), backupCtx = backup.getContext('2d');
  if (!ctx || !patchCtx || !backupCtx) throw new Error('Animated backgrounds are unavailable in this browser.');
  const duration = frames.reduce((sum, frame) => sum + frame.delay, 0);
  let index = -1;
  const frameAt = time => {
    let remaining = ((time * 1000) % duration + duration) % duration, target = 0;
    while (target < frames.length - 1 && remaining >= frames[target].delay) { remaining -= frames[target].delay; target++; }
    if (target < index) { index = -1; ctx.clearRect(0, 0, width, height); backupCtx.clearRect(0, 0, width, height); }
    while (index < target) {
      const previous = frames[index];
      if (previous?.disposalType === 2) { const d = previous.dims; ctx.clearRect(d.left, d.top, d.width, d.height); }
      else if (previous?.disposalType === 3) { ctx.clearRect(0, 0, width, height); ctx.drawImage(backup, 0, 0); }
      const frame = frames[++index], d = frame.dims;
      if (frame.disposalType === 3) { backupCtx.clearRect(0, 0, width, height); backupCtx.drawImage(canvas, 0, 0); }
      patch.width = d.width; patch.height = d.height;
      const data = patchCtx.createImageData(d.width, d.height); data.data.set(frame.patch); patchCtx.putImageData(data, 0, 0); ctx.drawImage(patch, d.left, d.top);
    }
    return canvas;
  };
  frameAt(0); return { canvas, frameAt, duration: duration / 1000 };
}
